import React, { useState, useEffect, useRef } from 'react';

const EXIT_MS = 500; // transition 500ms 완료 후 언마운트

export default function Toast({ message, duration, maxWidth = '280px', width = null, balance = true, position = 'top', onClose, onClick, className = '' }) {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    let showTimer = null;
    let hideTimer = null;
    let removeTimer = null;

    if (message) {
      setShouldRender(true);
      const msgStr = typeof message === 'string' ? message : String(message || '');
      const finalDuration = duration !== undefined ? duration : Math.max(2000, Math.min(5000, 2000 + [...msgStr].length * 60));
      const displayDuration = Math.max(0, finalDuration - EXIT_MS);

      // 마운트 직후 다음 프레임에 애니메이션 등장 트리거
      showTimer = setTimeout(() => {
        setIsVisible(true);
      }, 15);

      hideTimer = setTimeout(() => {
        setIsVisible(false);
        removeTimer = setTimeout(() => {
          setShouldRender(false);
          if (onCloseRef.current) onCloseRef.current();
        }, EXIT_MS);
      }, displayDuration);
    } else {
      setIsVisible(false);
      removeTimer = setTimeout(() => {
        setShouldRender(false);
      }, EXIT_MS);
    }

    return () => {
      if (showTimer) clearTimeout(showTimer);
      if (hideTimer) clearTimeout(hideTimer);
      if (removeTimer) clearTimeout(removeTimer);
    };
  }, [message, duration]);

  if (!shouldRender || !message) return null;

  // className prop이 제공되지 않으면 position 값에 따라 기본 위치 계산
  let positionClass = className;
  if (!positionClass) {
    if (position === 'center') {
      positionClass = 'fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2';
    } else if (position === 'bottom') {
      positionClass = 'fixed left-1/2 -translate-x-1/2 bottom-[calc(env(safe-area-inset-bottom,0px)+96px)]';
    } else {
      positionClass = 'fixed top-[calc(env(safe-area-inset-top,0px)+76px)] left-1/2 -translate-x-1/2';
    }
  }

  return (
    <div
      onClick={onClick}
      style={{
        maxWidth,
        ...(width ? { width } : {}),
        ...(balance ? {} : { textWrap: 'pretty' }),
      }}
      className={`${positionClass} z-[100] bg-[#fbf9f1] text-[#006565] border-2 border-[#006565] px-4 py-2.5 rounded-2xl font-label-md text-label-md shadow-lg text-center leading-snug whitespace-pre-line break-keep [overflow-wrap:anywhere] text-balance transition-all duration-500 ease-out ${
        onClick ? 'pointer-events-auto cursor-pointer' : 'pointer-events-none'
      } ${
        isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
      }`}
    >
      {message}
    </div>
  );
}
